"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecaptchaProvider = RecaptchaProvider;
exports.default = void 0;
function RecaptchaProvider(id, siteKey, callback) {
  var isScriptExist = document.getElementById(id);
  if (!isScriptExist) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = "https://www.google.com/recaptcha/api.js?render=".concat(siteKey);
    script.id = id;
    script.onload = function () {
      if (callback) callback();
    };
    document.body.appendChild(script);
  }
  if (isScriptExist && callback) callback();
}
var _default = RecaptchaProvider;
exports.default = _default;